import { Link, useLocation } from 'react-router-dom';
import { Play, Radio } from 'lucide-react';
import { useMatches } from '@/hooks';
import { ROUTES } from '@/constants';
import { MATCH_STATUS } from '@/constants/matches';

function ScorerLiveBanner() {
  const location = useLocation();
  const { data } = useMatches({
    status: MATCH_STATUS.LIVE,
    limit: 1,
    sortBy: 'scheduledAt',
    sortOrder: 'asc',
  });

  const match = data?.matches?.[0];
  if (!match) return null;

  const scorerUrl = ROUTES.SCORER_PANEL.replace(':matchId', match._id);
  if (location.pathname === scorerUrl) return null;

  return (
    <Link
      to={scorerUrl}
      className="flex items-center gap-3 border-b border-error/20 bg-error/10 px-4 py-2.5 transition-colors hover:bg-error/15 md:px-6"
    >
      <Radio className="h-4 w-4 shrink-0 animate-pulse text-error" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold">
          {match.teamA?.shortName || match.teamA?.name} vs{' '}
          {match.teamB?.shortName || match.teamB?.name} is live
        </p>
        <p className="truncate text-xs text-muted-foreground">
          {match.matchNumber ? `Match #${match.matchNumber} · ` : ''}Tap to continue scoring
        </p>
      </div>
      <span className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-error px-3 py-1.5 text-xs font-semibold text-white">
        <Play className="h-3.5 w-3.5" aria-hidden="true" />
        Score
      </span>
    </Link>
  );
}

export default ScorerLiveBanner;
